import { StoryApiResponse } from 'api/api.types';
import { Flex, spacing } from 'deepstash-ui';
import React from 'react';
import BackButton from 'src/components/breadcrumbs/BackButton';
import BreadcrumbList from 'src/components/breadcrumbs/BreadcrumbList';
import Footer from 'src/components/layout/components/Footer';
import FullWidthSectionWrapper from 'src/components/layout/components/FullWidthSectionWrapper';
import Navbar from 'src/components/navbar/Navbar';
import { GAP_SIZE_REM, slugify } from 'utils/global';
import StoryPageContent from './components/StoryPageContent';
import StoryPageHeader from './components/StoryPageHeader';

interface StoryPageProps {
  story: StoryApiResponse;
}

const StoryPage: React.FC<StoryPageProps> = ({ story }) => {
  return (
    <>
      <Flex width="100%" flexDirection="column" pb={32}>
        <FullWidthSectionWrapper
          containerProps={{
            flexDirection: 'column',
            gridGap: 0,
          }}
        >
          <Navbar />
          <BreadcrumbList
            items={[
              { title: 'All Stories', link: '/stories' },
              { title: story.title, link: `/stories/${slugify(story.title)}` },
            ]}
          />
        </FullWidthSectionWrapper>
        <FullWidthSectionWrapper
          containerProps={{
            flexDirection: 'column',
            gridGap: 8,
            alignItems: 'start',
          }}
          marginTop={{ base: spacing.M.rem, md: GAP_SIZE_REM }}
        >
          <BackButton
            location="story"
            customData={{ pageTitle: 'All Stories', pageLink: '/stories' }}
          />
          <StoryPageHeader story={story} />
        </FullWidthSectionWrapper>
        <FullWidthSectionWrapper
          mt={32}
          containerProps={{ flexDirection: 'column', px: 0 }}
        >
          <StoryPageContent story={story} />
        </FullWidthSectionWrapper>
      </Flex>

      <Footer />
    </>
  );
};

export default StoryPage;
